import { render, staticRenderFns } from "./table-2.vue?vue&type=template&id=0fc347fe&scoped=true"
import script from "./table-2.vue?vue&type=script&lang=js"
export * from "./table-2.vue?vue&type=script&lang=js"
import style0 from "./table-2.vue?vue&type=style&index=0&id=0fc347fe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc347fe",
  null
  
)

export default component.exports